@if (isLoading) {
  <app-view-loader [loading]="isLoading"></app-view-loader>
} @else {
  @if (showSourcingCampaignSection()) {
    <div class="view-section mb-3">
      <h5>
        {{
          'company-tool.views.jobs.posting.sections.publication.sourcing-campaign.headline'
            | transloco
        }}
      </h5>
      @if (selectedSourcingPlatform(); as sourcingPlatform) {
        <div class="ct-card plan-card mt-3">
          <div class="plan-card-main">
            <div class="plan-card-info">
              <div class="plan-card-title">
                <h5>
                  {{
                    (isSourcedJobsAutopilot(sourcingPlatform.id)
                      ? 'company-tool.snippets.sourcing-campaign-booking-modal.options.autopilot.title'
                      : 'company-tool.snippets.sourcing-campaign-booking-modal.options.leads.title'
                    ) | transloco
                  }}
                </h5>
              </div>
              <p class="plan-card-price">
                {{
                  'company-tool.views.jobs.posting.sections.publication.sourcing-campaign.credits'
                    | transloco
                      : { credits: sourcingPlatform.price | number: '1.0-0' }
                }}
              </p>
            </div>
            <div class="plan-card-actions">
              <app-button
                variant="white-red"
                [iconStart]="fontawesomeService.light.trash"
                [ariaLabel]="
                  'company-tool.views.jobs.posting.sections.publication.sourcing-campaign.remove'
                    | transloco
                "
                (click)="clearSourcingCampaignSelection()"
              ></app-button>
            </div>
          </div>
        </div>
      } @else {
        <div class="ct-card plan-card plan-card-cta mt-3">
          <div class="plan-card-main">
            <div class="plan-card-info">
              <div class="plan-card-title">
                <h5>
                  {{
                    'company-tool.views.jobs.posting.sections.publication.sourcing-campaign.cta-title'
                      | transloco
                  }}
                </h5>
              </div>
              <p class="plan-card-meta">
                {{
                  'company-tool.views.jobs.posting.sections.publication.sourcing-campaign.cta-text'
                    | transloco
                }}
              </p>
            </div>
            <div class="plan-card-actions">
              <app-button
                variant="white-grey"
                [iconStart]="fontawesomeService.light.users"
                (click)="openSourcingCampaignModal()"
              >
                {{
                  'company-tool.views.jobs.posting.sections.publication.sourcing-campaign.book-button'
                    | transloco
                }}
              </app-button>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (displayedFreeJobPlatforms().length) {
    <div class="view-section mb-3">
      <h5 [class.mt-5]="showSourcingCampaignSection()">
        {{
          'company-tool.views.jobs.posting.sections.publication.job-markets.regular-jobs.title'
            | transloco
        }}
      </h5>
      @if (!screenService.isMobile) {
        <div class="table-wrapper mt-3">
          <p-table
            id="campaign-publish-free-channels"
            class="jobplatforms"
            [value]="displayedFreeJobPlatforms()"
            dataKey="id"
          >
            <ng-template #header>
              <tr>
                <th style="width: 10%"></th>
                <th>
                  {{
                    'company-tool.views.jobs.posting.sections.publication.table.headers.portal'
                      | transloco
                  }}
                </th>
                <th style="width: 15%" class="text-center">
                  {{
                    'company-tool.views.jobs.posting.sections.publication.table.headers.duration'
                      | transloco
                  }}
                </th>
                <th style="width: 15%" class="text-center">
                  {{
                    'company-tool.views.jobs.posting.sections.publication.table.headers.price'
                      | transloco
                  }}
                </th>
                <th style="width: 10%" class="text-center">
                  {{
                    'company-tool.views.jobs.posting.sections.publication.table.headers.publish'
                      | transloco
                  }}
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-platform>
              <tr>
                <td>
                  <img
                    [src]="platform.logoURL"
                    [alt]="'Logo - ' + platform.title"
                    loading="lazy"
                  />
                </td>
                <td>{{ platform.title }}</td>
                <td class="text-center">
                  @if (platform.duration !== null) {
                    {{ platform.duration }}
                    {{
                      'company-tool.views.jobs.posting.sections.publication.job-markets.days'
                        | transloco
                    }}
                  } @else {
                    <fa-icon [icon]="fontawesomeService.light.infinity"></fa-icon>
                  }
                </td>
                <td class="text-center">
                  @if (platform.price === 0) {
                    {{
                      'company-tool.views.jobs.posting.sections.publication.job-markets.free'
                        | transloco
                    }}
                  } @else {
                    {{ platform.price | formatPrice }}
                  }
                </td>
                <td class="text-center">
                  <input
                    type="checkbox"
                    [checked]="platform.selected"
                    (click)="
                      $event.preventDefault();
                      onPlatformSelectionChange(platform)
                    "
                  />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      @if (screenService.isMobile) {
        <ul class="platformlist-mobile">
          @for (
            platform of displayedFreeJobPlatforms();
            track trackPlatformsBy($index, platform)
          ) {
            <li>
              <div>
                <input
                  type="checkbox"
                  [checked]="platform.selected"
                  (click)="
                    $event.preventDefault();
                    onPlatformSelectionChange(platform)
                  "
                />
              </div>
              <img
                [src]="platform.logoURL"
                [alt]="'Logo - ' + platform.title"
                loading="lazy"
              />
              <div>
                <h5>{{ platform.title }}</h5>
                <div>
                  <ct-lib-tag>
                    <fa-icon [icon]="fontawesomeService.light.euroSign"></fa-icon>
                    @if (platform.price === 0) {
                      {{
                        'company-tool.views.jobs.posting.sections.publication.job-markets.free'
                          | transloco
                      }}
                    } @else {
                      {{ platform.price | formatPrice }}
                    }
                  </ct-lib-tag>
                  <ct-lib-tag>
                    <fa-icon [icon]="fontawesomeService.light.clock"></fa-icon>
                    @if (platform.duration !== null) {
                      {{ platform.duration }}
                      {{
                        'company-tool.views.jobs.posting.sections.publication.job-markets.days'
                          | transloco
                      }}
                    } @else {
                      <fa-icon [icon]="fontawesomeService.light.infinity"></fa-icon>
                    }
                  </ct-lib-tag>
                </div>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  }
  <div class="view-section mb-3">
    <app-contract-selector #contractSelector></app-contract-selector>
  </div>
  <div class="view-section mb-3">
    <app-job-platforms-browser
      (selectedPlatformsOutput)="onAdditionalPlatformSelectionChange($event)"
      #jobPlatformsBrowser
    ></app-job-platforms-browser>
  </div>

  <h5>
    {{
      'company-tool.views.campaigns.publish.selected-platforms-title'
        | transloco
    }}
  </h5>
  <app-platforms-pricing-list
    [selectedPlatforms]="payablePlatforms()"
  ></app-platforms-pricing-list>

  <ng-template
    #titleWithDescription
    let-jobPlatform="jobPlatform"
    let-isModalView="isModalView"
  >
    <ng-container>
      <td class="title-with-description" id="{{ jobPlatform.id }}">
        <span>
          {{ jobPlatform.title }}
          @if (jobPlatform.crossPostings.length > 0) {
            <fa-icon
              class="cross-posting-icon"
              [icon]="fontawesomeService.light.shareNodes"
              (click)="
                openJobCrossPostingModal(jobCrossPostingModal, jobPlatform)
              "
            ></fa-icon>
          }
        </span>
        <span
          [ngClass]="{
            'description-short-wrapper': !showMoreStates[jobPlatform.id],
          }"
        >
          <p
            [ngClass]="{
              'description-short':
                !showMoreStates[jobPlatform.id] && !isModalView,
              'description-short-modal':
                !showMoreStates[jobPlatform.id] && isModalView,
              'description-long': showMoreStates[jobPlatform.id],
            }"
            class="description-container"
          >
            {{ jobPlatform.description }}
          </p>
          <button
            (click)="
              showMoreStates[jobPlatform.id] = !showMoreStates[jobPlatform.id]
            "
            class="btn-show-more"
          >
            {{
              showMoreStates[jobPlatform.id]
                ? ('company-tool.views.jobs.posting.sections.publication.job-markets.show.less'
                  | transloco)
                : ('company-tool.views.jobs.posting.sections.publication.job-markets.show.more'
                  | transloco)
            }}
          </button>
        </span>
      </td>
    </ng-container>
  </ng-template>

  <ct-lib-modal
    [label]="
      'company-tool.views.jobs.posting.sections.publication.job-markets.cross-posting-modal.title'
        | transloco
    "
    class="jobplatforms-modal"
    (onCloseEnd)="jobPlatformFilter.reset()"
    #jobCrossPostingModal
  >
    <div class="table-wrapper">
      <p-table [value]="jobCrossPostings">
        <ng-template #header>
          <tr>
            <th class="text-center">
              {{
                'company-tool.views.jobs.posting.sections.publication.table.headers.portal'
                  | transloco
              }}
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-crossPosting>
          <tr>
            <td class="text-center">{{ crossPosting }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ct-lib-modal>

  <ng-template #totalDeliveryTimePerDays let-jobPlatform="jobPlatform">
    <td class="text-center">
      {{ jobPlatform.totalDeliveryTimePerDays }}
      {{ 'company-tool.views.dashboard.sections.key-figures.days' | transloco }}
    </td>
  </ng-template>
}

<app-sourcing-campaign-booking-modal
  #sourcingCampaignBookingModal
  [requiresCredits]="true"
  (confirmed)="onSourcingCampaignConfirmed($event)"
></app-sourcing-campaign-booking-modal>
